import { render } from "./TemplateEditor.vue?vue&type=template&id=627f2477"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"

import "./TemplateEditor.vue?vue&type=style&index=0&id=627f2477&lang=scss"
script.render = render

export default script